var progressCircle = {
    base: {
        position: "relative",
    },
    variants: {
        size: {
            lg: {
                width: "100px",
                height: "100px",
                font: "h2",
            },
            md: {
                width: "80px",
                height: "80px",
                font: "h4",
            },
            sm: {
                width: "64px",
                height: "64px",
                font: "h6",
            },
        },
    },
};
var progressCircleValue = {
    base: {
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        height: "100%",
        justifyContent: "center",
        position: "absolute",
        top: 0,
        width: "100%",
        "& > sup": {
            fontWeight: "normal",
        },
    },
};

export { progressCircle, progressCircleValue };
//# sourceMappingURL=progress-circle.js.map
